import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SecurityManagementComponent } from './security-management.component';

const routes: Routes = [
  {
    path: '',
    component: SecurityManagementComponent,
    children: [
      {
        path: 'blacklist-ip',
        loadChildren: () => import('./blacklist-ip-management/blacklist-ip-management.module').then(m => m.BlacklistIpManagementModule),
      },
      {
        path: 'view-all-lead-requests',
        loadChildren: () => import('./all-lead-request/all-lead-request.module').then(m => m.AllLeadRequestModule),
      },
      {
        path: 'web-lead-requests',
        loadChildren: () => import('./web-lead-request/web-lead-request.module').then(m => m.WebLeadRequestModule),
      },
      {
        path: 'post-lead-requests',
        loadChildren: () => import('./post-lead-request/post-lead-request.module').then(m => m.PostLeadRequestModule),
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SecurityManagementRoutingModule { }
